/**
 * Keep sidebar/header/main inset transitions off during first paint.
 * Enable them only after hydration has had time to settle the stored state.
 */
export function useLayoutInsetTransition() {
  const layoutInsetTransition = ref(false)

  onMounted(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        layoutInsetTransition.value = true
      })
    })
  })

  return { layoutInsetTransition }
}
